import i18n from "@/locales";
import { useMate } from "@/stores/mate";
import { showConfirmDialog } from "vant";

export const MinOneTimePaidAmount = 0.5;
export const MinSuperAdmireAmount = 9.99;

export const checkMateMediaPayment = (
  visibility: VisibilityStatus,
  price: number,
  admirePrice = useMate().currentMate?.superAdmirePrice!
) => {
  if ([6, 8].includes(visibility!)) {
    if (price < MinOneTimePaidAmount) {
      showConfirmDialog({
        message: i18n.global.t("Message.donateTooLow", { amount: 5 }),
        showCancelButton: false,
        confirmButtonText: i18n.global.t("Buttons.ok"),
      });
      return false;
    }

    if (price > 10000) {
      showConfirmDialog({
        message: i18n.global.t("Message.donateTooHigh"),
        showCancelButton: false,
        confirmButtonText: i18n.global.t("Buttons.ok"),
      });
      return false;
    }
  }

  if ([7, 8].includes(visibility!)) {
    if (admirePrice < MinSuperAdmireAmount) {
      showConfirmDialog({
        message:
          i18n.global.t(`purchase.item.sub`) +
          " " +
          i18n.global.t("User.admire.minPayTip", {
            amount: MinSuperAdmireAmount,
          }),
        confirmButtonText: i18n.global.t("Buttons.confirm"),
        showCancelButton: false,
      });
      return false;
    }
  }
  return true;
};
